import type { JsonObject } from '../../types/content';

export function text(content: JsonObject, key: string, fallback = ''): string {
  return typeof content[key] === 'string' ? content[key] : fallback;
}

export function strings(content: JsonObject, key: string): string[] {
  const value = content[key];
  return Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];
}

export function objects(content: JsonObject, key: string): JsonObject[] {
  const value = content[key];
  return Array.isArray(value)
    ? value.filter((item): item is JsonObject => Boolean(item) && typeof item === 'object' && !Array.isArray(item))
    : [];
}

export function numberField(content: JsonObject, key: string, fallback = 0): number {
  return typeof content[key] === 'number' ? content[key] : fallback;
}
